import { BookingSteps } from "../../../../_common/steps/booking-steps"
import { ECommerceState } from "./e-commerce-machine"
import { ECommerceReadyToCheckoutContext, ECommerceSuiteNumberSelectedV4Context } from "./e-commerce-machine-context"

export const canGoToGuestsV4 = (state: ECommerceState): boolean => canChangeAnything(state)

export const canGoToFareV4 = (state: ECommerceState) =>
    state.matches("flow.suiteCategorySelectedV4") ||
    state.matches("flow.fareSelectedV4") ||
    state.matches("flow.suiteNumberSelectedV4") ||
    state.matches("flow.flightSelected")

export const canGoToCategoriesV4 = (state: ECommerceState): boolean => canSelectSuiteCategoryV4(state)
export const canSelectSuiteCategoryV4 = <T extends ECommerceState>(state: T) =>
    state.matches("flow.nothingSelectedV4") ||
    state.matches("flow.suiteCategorySelectedV4") ||
    state.matches("flow.fareSelectedV4") ||
    state.matches("flow.suiteNumberSelectedV4") ||
    state.matches("flow.flightSelected")

export const canGoToSendQuoteV4 = (state: ECommerceState): boolean =>
    state.matches("flow.fareSelectedV4") || state.matches("flow.suiteNumberSelectedV4")

export const canGoToAddons = (state: ECommerceState): boolean =>
    state.matches("flow.suiteNumberSelectedV4") || state.matches("flow.flightSelected")

export const canGoToGuestsInfoV4 = (state: ECommerceState): boolean => canFillGuestsInfoV4(state)
export const canFillGuestsInfoV4 = <T extends ECommerceState>(state: T) =>
    //keep-line
    state.matches("flow.flightSelected")

export const isCheckout = <T extends ECommerceState>(
    state: T,
): state is T & { context: ECommerceSuiteNumberSelectedV4Context } => state.matches("flow.checkout")

export const isWebQuote = <T extends ECommerceState>(
    state: T,
): state is T & { context: ECommerceSuiteNumberSelectedV4Context } => state.matches("flow.webQuote")

export const isCourtesyHold = <T extends ECommerceState>(
    state: T,
): state is T & { context: ECommerceSuiteNumberSelectedV4Context } => state.matches("flow.courtesyHold")

export const isReadyToCheckout = <T extends ECommerceState>(
    state: T,
): state is T & { context: ECommerceReadyToCheckoutContext } =>
    state.matches("flow.checkout.validated") ||
    state.matches("flow.readyToCheckout.starting") ||
    state.matches("flow.readyToCheckout.paying") ||
    state.matches("flow.readyToCheckout.error") ||
    state.matches("flow.readyToCheckout.completed")

export const isPayment = <T extends ECommerceState>(
    state: T,
): state is T & { context: ECommerceReadyToCheckoutContext } => state.matches("flow.readyToCheckout")

const canChangeAnything = (state: ECommerceState) =>
    !isWebQuote(state) && !isCourtesyHold(state) && !isCheckout(state) && !isPayment(state)

export const canGoToPayments = (state: ECommerceState): boolean => state.matches("flow.checkout.validated")

export const canGoToNextStep = (currentStep: BookingSteps, state: ECommerceState): boolean =>
    state.context.flowVersion.steps.canGoToNextStep(currentStep, state)
